<template>
  <SearchWithFilter
    v-model="filter"
    :filters="filters"
    @search="search"
    selectedFilterCacheKey="itemSearchInputFilter"
  />
</template>

<script>
import shared from '@/shared/shared';
import SearchWithFilter from '@/components/common/search-with-filter.vue';

export default {
  name: 'ItemSearchInput',
  components: {
    SearchWithFilter
  },

  props: {
    label: String,

    orderItems: {
      type: Array,
      default: () => []
    },

    elementIdPrefix: {
      type: String,
      default: 'order-item-'
    },

    useUUidAsElementId: {
      type: Boolean,
      default: false
    },

    onSingleMatch: {
      type: Function,
      default: null
    },

    highlightHandler: {
      type: Function,
      default: null
    },

    updateSearchTerm: {
      type: Function,
      default: null
    },

    afterSearch: {
      type: Function,
      default: null
    },
  },

  data() {
    return {
        filter: '',
        searchTerm: '',
        highlightedIndexes: [],
        highlightedIds: [],
        filters:  [{ value: 'all', text: 'Todos' }].concat(shared.ITEM_SEARCH_DEFAULT_FIELDS),

    }
  },

  methods: {
    highlightText(text, index) {
      if (this.searchTerm) {
        if (this.highlightedIndexes.includes(index) || this.highlightedIds.includes(index)) {
          return shared.highlightText(text, this.searchTerm)
        }
      }

      return text;
    },

    search({ value, filter }) {
        this.searchTerm = value || '';
        if (this.updateSearchTerm) {
          this.updateSearchTerm(this.searchTerm);        
        }
        
        const foundItems = shared.filterByItemsSearch(
          { value, filter },
          this.orderItems
        )

        if (!foundItems.length) {
            this.$notify.warn('Nenhum item encontrado');
            this.highlightedIndexes = [];
            return;
        }

        if (this.onSingleMatch && foundItems.length === 1) {
          this.onSingleMatch(foundItems[0]);
          return;
        }

        if (this.highlightHandler) {
          this.highlightHandler(foundItems);
          return;
        }

        const indexes = foundItems.map(item =>
          this.orderItems.indexOf(item)
        )

        const firstItem = foundItems[0];

        const firstIndex = indexes[0];

        this.highlightedIndexes = indexes

        this.highlightedIds = foundItems.map(item => item.id)

        if (this.afterSearch) {
          this.afterSearch(foundItems);
        }

        this.$nextTick(() => {
          let id = this.useUUidAsElementId ? firstItem.id : this.elementIdPrefix + firstIndex
          const el = document.getElementById(id)
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }
        })
    },
  }
}
</script>